"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var core_1 = require("@angular/core");
var UserSessionIdentityIntercepter = /** @class */ (function () {
    function UserSessionIdentityIntercepter(cookieService) {
        this.cookieService = cookieService;
        if (!cookieService.get('suid')) {
            var value = Math.random().toString(36).substring(7);
            var date = new Date();
            date.setTime(date.getTime() + (10 * 365 * 24 * 60 * 60 * 1000));
            cookieService.set('suid', UserSessionIdentityIntercepter_1._ssid, date, '/');
        }
    }
    UserSessionIdentityIntercepter_1 = UserSessionIdentityIntercepter;
    UserSessionIdentityIntercepter.prototype.intercept = function (req, next) {
        var clonedReq = req.clone({
            headers: req.headers.set('ssid', UserSessionIdentityIntercepter_1._ssid)
        });
        return next.handle(clonedReq);
    };
    var UserSessionIdentityIntercepter_1;
    UserSessionIdentityIntercepter._2Power64 = Math.pow(2, 64);
    UserSessionIdentityIntercepter._ssid = Math.floor(Math.random() * UserSessionIdentityIntercepter_1._2Power64).toString(16) + '-' + new Date().getTime();
    UserSessionIdentityIntercepter._suid = Math.floor(Math.random() * UserSessionIdentityIntercepter_1._2Power64).toString(16) + '-' + new Date().getTime();
    UserSessionIdentityIntercepter = UserSessionIdentityIntercepter_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_authentication_client_js_1.CookieService])
    ], UserSessionIdentityIntercepter);
    return UserSessionIdentityIntercepter;
}());
exports.UserSessionIdentityIntercepter = UserSessionIdentityIntercepter;
//# sourceMappingURL=user-session-identity.intercepter.js.map